import { ServiceMaker, methods, services } from ".";

export const paymentHistory = data =>
  ServiceMaker(
    "/subscription-payments/subscription-pricing/filter/my",
    methods.POST,
    services.master,
    data
  );

export const createPartnerPayment = data =>
  ServiceMaker(
    "/subscription-payments/subscription-pricing",
    methods.POST,
    services.master,
    data
  );
